import Nullstack from 'nullstack';
export default function IconSignal4gPlus({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-signal-4g-plus",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M3 8v5h5"
  }), "   ", Nullstack.element("path", {
    d: "M7 8v8"
  }), "   ", Nullstack.element("path", {
    d: "M15 8h-2a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h2v-4h-1"
  }), "   ", Nullstack.element("path", {
    d: "M18 12h4"
  }), "   ", Nullstack.element("path", {
    d: "M20 10v4"
  }), " ");
}